import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'

export const loaderWrapper = css`
  height: 50vh;
  width: 80vw;
  display: flex;
  align-items: center;
  justify-content: center;
  ${MQ.PHONES} {
    height: 50vh;
    width: 100vw;
  }
`
